module.exports = __webpack_public_path__ + "img/cnd.46b73778.svg";